import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgHealthCFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#health-c-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M56 34.21a28 28 0 0 0-56 0h56"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M24.575 30.082c-2.16.937-4.026 1.194-6.114 2.283-1.398.73-2.708 1.631-4.147 2.278-1.438.646-3.07 1.027-4.6.642-.499-.126-1.073-.488-.984-.995.05-.286.3-.488.532-.663l10.04-7.525c1.341-1.005 2.71-2.024 4.294-2.574.854-.296 1.789-.447 2.665-.23.875.219 1.684.859 1.922 1.731.316 1.158-.402 2.333-1.229 3.195-.699.728-1.452 1.456-2.379 1.858"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: `health-c-fidelity-low_svg__b-${id}`,
        width: 56,
        height: 39,
        x: 0,
        y: 10,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M40.22 10.354c12.933.479 15.543 6.422 15.78 10.352v27.893H0V10.354z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: `url(#health-c-fidelity-low_svg__b-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M58.75 2.1S31.44 21.96 30.044 22.552s-2.745.3-5.058.552c-2.312.251-3.693.988-4.667 2.772-.701 1.283-.632 4.051-.543 5.505.04.63-.094 1.258-.387 1.817l-.976 1.868a2.24 2.24 0 0 1-1.122 1.03s-4.73 1.245-12.684 3.623a3.75 3.75 0 0 0-1.588.888c-.393.394-.603 1.113-.175 1.474.24.2.586.197.9.185 3.782-.158 14.977-.675 18.77-1.638 1.696-.434 10.089-10.708 10.089-10.708l27.276-13.726z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "m29.335 33.804-6.279.335q-.104.315-.266.603l-1.034 1.837c-.258.458-.668.81-1.158.998 0 0-4.767 1.096-12.792 3.225-.599.143-1.154.432-1.614.842a1.5 1.5 0 0 0-.358.531c4.81-.226 13.442-.723 16.68-1.545.99-.253 4.267-3.866 6.82-6.826",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M23.055 34.823q-.105.313-.266.603l-1.035 1.836c-.258.458-.667.811-1.158.998 0 0-4.767 1.097-12.791 3.225-.6.143-1.154.432-1.615.842-.406.38-.637 1.094-.22 1.463.233.21.578.217.892.21 3.789-.038 14.992-.21 18.812-1.052 1.27-.281 6.42-5.894 8.969-8.743z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M26.134 35.29q.145-.298.231-.618l1.004-.112 7.118-.38c-2.55 2.85-7.698 8.463-8.97 8.744-3.09.681-11.017.923-15.937 1.012.031-.29.18-.592.382-.804a3.75 3.75 0 0 1 1.563-.93c7.894-2.588 12.589-3.959 12.589-3.959a2.24 2.24 0 0 0 1.092-1.059z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M26.503 35.492q-.086.32-.232.618l-.927 1.894a2.24 2.24 0 0 1-1.092 1.06s-4.695 1.37-12.59 3.958a3.75 3.75 0 0 0-1.562.93c-.383.403-.574 1.13-.137 1.474.246.194.591.183.904.162 3.777-.258 14.955-1.073 18.72-2.137 1.252-.354 6.067-6.25 8.449-9.246z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M35.145 37.758h-4.057a3.7 3.7 0 0 1-.315.623l-1.2 1.885a2.38 2.38 0 0 1-1.274.99s-5.107.892-13.716 2.69c-.632.133-1.263.379-1.756.797a1.55 1.55 0 0 0-.481.742c4.646-.335 13.885-1.085 17.24-2.033.845-.239 3.312-3.002 5.559-5.694",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M31.908 38.437a3.7 3.7 0 0 1-.316.624l-1.199 1.885a2.38 2.38 0 0 1-1.275.99s-5.106.892-13.716 2.69c-.631.133-1.263.379-1.755.797-.452.38-.737 1.122-.316 1.535.236.234.6.263.932.277 4.008.172 15.874.632 19.963-.05 1.361-.226 7.123-5.87 9.983-8.745z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M17.156 47.35c5.197.187 13.73.392 17.071-.165 1.361-.225 7.123-5.869 9.984-8.744 2.22-3.08-2.32-4.122-7.874-2.156-.07.65-.108 1.256-.13 1.732a3.66 3.66 0 0 1-.615 1.87l-1.244 1.855a2.38 2.38 0 0 1-1.299.956s-5.126.768-13.776 2.357c-.638.117-1.27.349-1.775.754-.46.37-.764 1.104-.355 1.528z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M11.116 17.032c-4.577 8.36 1.114 17.96 16.55 28.451 15.437-10.49 21.128-20.09 16.551-28.45-3.408-6.228-12.257-6.425-16.55-1.482-4.294-4.943-13.143-4.746-16.551 1.481"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        fillRule: "evenodd",
        d: "M43.245 15.588c-3.896-4.777-11.647-4.56-15.578-.034-4.294-4.943-13.143-4.746-16.551 1.481-1.25 2.285-1.735 4.662-1.463 7.124 2.844 4.626 8.036 9.5 15.517 14.585 12.272-8.34 18.384-16.117 18.075-23.156",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        d: "M46.2 36.665c-2.51.778-4.614.837-7.061 1.793-1.64.64-3.202 1.482-4.878 2.024-1.675.542-3.53.768-5.177.156-.539-.2-1.133-.67-.973-1.224.091-.31.393-.505.672-.67l12.05-7.134c1.612-.952 3.254-1.918 5.077-2.335.984-.23 2.037-.28 2.984.068.947.347 1.766 1.15 1.924 2.151.21 1.318-.728 2.54-1.751 3.397-.87.724-1.794 1.44-2.867 1.774"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M55.324 38.592c1.066-3.218.55-7.566-1.374-9.541-1.005.268-1.964.189-3.167.089-.742-.062-1.579-.131-2.577-.131-2.693 0-4.372.673-5.724 2.604-.968 1.39-1.24 4.585-1.316 6.27a4 4 0 0 1-.673 2.045l-1.36 2.028A2.6 2.6 0 0 1 37.713 43s-5.604.84-15.06 2.577c-.698.128-1.388.38-1.94.824-.504.404-.836 1.207-.389 1.67.254.262.65.302 1.013.327 4.372.294 17.332 1.106 21.82.473 1.678-.236 9.613-7.807 12.167-10.28",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `health-c-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgHealthCFidelityLow;
